/* eslint-disable */
import React, { useState } from 'react';
import { Grid, Typography } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { CopyIconButton, maskData } from 'utils/commonUtil';
import { gridSpacing } from 'store/constant';

export default function MachineConfiguration({ machineDetails }) {
  const [viewApi, setViewApi] = useState(false);

  return (
    <Grid container spacing={gridSpacing} style={{ paddingTop: '30px' }}>
      <Grid item xs={12}>
        <div style={{ border: '1px solid #6fd74b', borderRadius: '6px' }}>
          <div className="address_locationmain" style={{ background: '#6fd74b', mb: 2, padding: '10px 15px' }}>
            <Typography
              component="h4"
              variant="h3"
              // sx={{ mr: 1, pb: 1.8 }}
              sx={{ color: '#fff' }}
            >
              Machine Configuration
            </Typography>
          </div>
          <Grid container spacing={gridSpacing} style={{ paddingTop: '10px', paddingBottom: '20px' }}>
            <Grid item sx={{ padding: 0 }}>
              <div style={{ marginLeft: 15, marginRight: 15 }}>
                <div className="address_locationmain" style={{ margin: 5, padding: '5px', display: 'inherit' }}>
                  <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                    Machine API Key :{' '}
                  </Typography>
                  {machineDetails?.apiKey ? (
                    <>
                      <Typography
                        variant="h5"
                        component={'span'}
                        sx={{ fontFamily: 'monospace', fontSize: 17, wordBreak: 'break-word', overflowWrap: 'break-word' }}
                      >
                        {viewApi ? machineDetails?.apiKey : maskData(machineDetails?.apiKey)} {/* Mask the key when hidden */}
                      </Typography>
                      <Typography variant="h5" component={'span'} sx={{ paddingTop: '5px' }}>
                        <span
                          onClick={() => setViewApi((prev) => !prev)}
                          aria-label="toggle visibility"
                          style={{ marginTop: 0, paddingRight: '6px', position: 'relative', top: '7px' }}
                        >
                          {viewApi ? <VisibilityOffIcon /> : <VisibilityIcon color="primary" />}
                        </span>
                        <CopyIconButton textToCopy={machineDetails?.apiKey} isIconDiv={true} />
                      </Typography>
                    </>
                  ) : (
                    'N.A.'
                  )}
                </div>
              </div>
            </Grid>

            <Grid item sx={{ padding: 0 }}>
              <div style={{ marginLeft: 15, marginRight: 15 }}>
                <div className="address_locationmain" style={{ margin: 5, padding: '5px', display: 'inherit' }}>
                  <Typography
                    variant="h4"
                    // component={machineDetails?.serialNumber ? 'p' : 'span'}
                    component={'span'}
                    style={{ fontWeight: 'bold' }}
                  >
                    Machine Serial Number :{' '}
                  </Typography>
                  <Typography
                    variant="h4"
                    // component={machineDetails?.serialNumber ? 'p' : 'span'}
                    component={'span'}
                    style={{ fontWeight: 'unset', paddingTop: 10 }}
                  >
                    {machineDetails?.serialNumber || 'N.A.'}
                  </Typography>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </Grid>
    </Grid>
  );
}
